class NorthAmericanSteelShapesComponent extends HTMLElement {

  constructor() {
    super();
    this.shapeType = 'w-shape'
    this.selectedShape = 'W8X15'

    this.shapeFiles = {
      'w-shape': 'AISC/W-shapes.json',
      'm-shape': 'AISC/M-shapes.json',
      's-shape': 'AISC/S-shapes.json',
      'hp-shape': 'AISC/HP-shapes.json',
      'c-shape': 'AISC/C-shapes.json',
      'mc-shape': 'AISC/MC-shapes.json',
      'wt-shape': 'AISC/WT-shapes.json',
      'mt-shape': 'AISC/MT-shapes.json',
      'st-shape': 'AISC/ST-shapes.json',
      'l-shape': 'AISC/L-shapes.json',
      'hss-square-shape': 'AISC/HSS-Square-shapes.json',
      'hss-rectangle-shape': 'AISC/HSS-Rectangle-shapes.json', 
      'hss-round-shape': 'AISC/HSS-Round-shapes.json',
      'pipe-shape': 'AISC/PIPE-shapes.json'

    }
    document.addEventListener('north-american-steel-shapes-selected', async () => this.onShapeCategorySelected(), true)
  }

  onShapeCategorySelected() {
    // update the tab
    this.onShapeFileClick(this.shapeType)
  }

  resetButton(id) {
    document.getElementById(id).classList.add('btn-default')
    document.getElementById(id).classList.remove('btn-primary')
  }

  onShapeFileClick(id) {
    this.shapeType = id
    getNorthAmericanSteelShapes(this.shapeFiles[id])
    // reset buttons
    this.resetButton('w-shape')
    this.resetButton('m-shape')
    this.resetButton('s-shape')
    this.resetButton('hp-shape')
    this.resetButton('c-shape')
    this.resetButton('mc-shape')
    this.resetButton('wt-shape')
    this.resetButton('mt-shape')
    this.resetButton('st-shape')
    this.resetButton('l-shape')
    this.resetButton('hss-square-shape')
    this.resetButton('hss-round-shape')
    this.resetButton('hss-rectangle-shape')
    this.resetButton('pipe-shape')
    document.getElementById(id).classList.add('btn-primary')
  }

  connectedCallback() {

    this.innerHTML = String.raw`
    <div class="my-2">
      <button class="btn btn-default button-shadow" id='w-shape'>W</button>
      <button class="btn btn-default button-shadow" id='m-shape'>M</button>
      <button class="btn btn-default button-shadow" id='s-shape'>S</button>
      <button class="btn btn-default button-shadow" id='hp-shape'>HP</button>
      <button class="btn btn-default button-shadow" id='c-shape'>C</button>
      <button class="btn btn-default button-shadow" id='mc-shape'>MC</button>
      <button class="btn btn-default button-shadow" id='wt-shape'>WT</button>
      <button class="btn btn-default button-shadow" id='mt-shape'>MT</button>
      <button class="btn btn-default button-shadow" id='st-shape'>ST</button>
      <button class="btn btn-default button-shadow" id='l-shape'>L</button>
    </div>
    <div  class="my-2">
      <button class="btn btn-default button-shadow" id='hss-square-shape'>HSS Square</button>
      <button class="btn btn-default button-shadow" id='hss-rectangle-shape'>HSS Rectangle</button>
      <button class="btn btn-default button-shadow" id='hss-round-shape'>HSS Round</button>
      <button class="btn btn-default button-shadow" id='pipe-shape'>Pipe</button>
    </div>
    `

    document.getElementById('w-shape').onclick = (() => this.onShapeFileClick('w-shape'))
    document.getElementById('m-shape').onclick = (() => this.onShapeFileClick('m-shape'))
    document.getElementById('s-shape').onclick = (() => this.onShapeFileClick('s-shape'))
    document.getElementById('hp-shape').onclick = (() => this.onShapeFileClick('hp-shape'))
    document.getElementById('c-shape').onclick = (() => this.onShapeFileClick('c-shape'))
    document.getElementById('mc-shape').onclick = (() => this.onShapeFileClick('mc-shape'))
    document.getElementById('wt-shape').onclick = (() => this.onShapeFileClick('wt-shape'))
    document.getElementById('mt-shape').onclick = (() => this.onShapeFileClick('mt-shape'))
    document.getElementById('st-shape').onclick = (() => this.onShapeFileClick('st-shape'))
    document.getElementById('l-shape').onclick = (() => this.onShapeFileClick('l-shape'))
    document.getElementById('hss-square-shape').onclick = (() => this.onShapeFileClick('hss-square-shape'))
    document.getElementById('hss-rectangle-shape').onclick = (() => this.onShapeFileClick('hss-rectangle-shape'))
    document.getElementById('hss-round-shape').onclick = (() => this.onShapeFileClick('hss-round-shape'))
    document.getElementById('pipe-shape').onclick = (() => this.onShapeFileClick('pipe-shape'))

    this.onShapeFileClick('w-shape')
  }

}

customElements.define('north-american-steel-shape-selector-component', NorthAmericanSteelShapesComponent)

